module.exports = __webpack_public_path__ + "img/06_ic_wire_clips_black_62px.b89926f9.svg";